class PrinciplesCarousel extends HTMLElement {
	connectedCallback() {
		if (typeof Swiper === 'undefined') {
			console.warn('Swiper not loaded — principles-carousel skipped');
			return;
		}

		const swiperEl = this.querySelector('.principles-carousel__swiper');
		if (!swiperEl) return;

		this.swiper = new Swiper(swiperEl, {
			slidesPerView: 1,
			spaceBetween: 24,
			watchOverflow: true,
			breakpoints: {
				750: { slidesPerView: 2, spaceBetween: 24 },
				990: { slidesPerView: 3, spaceBetween: 32 },
			},
			navigation: {
				nextEl: this.querySelector('.principles-carousel__btn--next'),
				prevEl: this.querySelector('.principles-carousel__btn--prev'),
				disabledClass: 'swiper-button-disabled',
			},
		});
	}

	disconnectedCallback() {
		if (this.swiper) {
			this.swiper.destroy(true, true);
			this.swiper = null;
		}
	}
}

if (!customElements.get('principles-carousel')) {
	customElements.define('principles-carousel', PrinciplesCarousel);
}
